<script>
const orderBy = require("lodash.orderby");
export default {
    name: "logo-masonry-grid",
    data() {
        return {
            items: companies
        };
    },
    computed: {
        categories() {
            return [
                ...new Set(this.items.map(item => item.categories[0]).sort())
            ];
        }
    },
    methods: {
        itemsByCategory(category) {
            return orderBy(
                this.items.filter(item => item.categories[0] == category),
                "name"
            );
        }
    }
};
</script>

<template>
    <div>
        <div v-for="category in categories" :key="category" class="flex -mx-3">
            <div class="md:w-1/5 px-3 text-right">
                <h3 class="mt-2 mb-6 text-xl text-purple">{{ category }}s</h3>
            </div>
            <div class="md:w-4/5 px-3">
                <div class="mb-8 white-card content">
                    <div class="flex flex-row flex-wrap justify-start items-center -mx-3">
                        <div
                            class="sm:w-1/2 md:w-1/3 lg:w-1/4 px-3"
                            v-for="company in itemsByCategory(category)"
                            :key="company.id"
                        >
                            <certified-company
                                :logo="company.logo"
                                :name="company.name"
                                :url="company.url"
                                :categories="company.categories"
                                :certificate="company.certificate"
                                class
                            ></certified-company>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
